
export const FeaturesData = [
  {
    color: "text-gray-800",
    title: "Equipos de Alta Precisión",
    icon: "Construction",
    description:
      "Utilizamos equipos y sistemas de alta tecnología especializados, adaptándonos a las exigencias del mercado y cumpliendo rigurosamente con las regulaciones vigentes. Nuestros sensores especializados y sondas de nivel ofrecen mediciones exactas para operaciones confiables y seguras.",
  },
  {
    color: "text-gray-800",
    title: "DataLogger y Cloud Avanzado",
    icon: "ContentPasteSearch",
    description:
    " Nuestros sistemas propios de DataLogger y Servidor Cloud recopilan y procesan datos en tiempo real, facilitando el envío automático de información crucial a la Dirección General de Aguas de Chile (DGA), garantizando así el cumplimiento normativo.",
  },
  {
    color: "text-gray-800",
    title: "Soluciones Personalizadas",
    icon: "Chat",
    description:
    "Gracias a nuestro desarrollo interno de tecnologías, podemos adaptarnos rápidamente a nuevas condiciones y exigencias del mercado. Nuestra plataforma es capaz de ajustarse de manera flexible a las necesidades de regulación y operación de nuestros clientes.",
  },
];

export default FeaturesData;
